module.exports = __webpack_public_path__ + "img/AC field.dbfec1f0.jpg";